import React from "react";
import "./index.css";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const services = [
  {
    title: "Digital Marketing Services",
    description:
      "From SEO, PPC advertising, social media marketing, and email campaigns, our digital marketing services help you connect with the right audience and maximize conversions.",
    icon: "/img/icons/icon-2.png",
    link: "/web-development-services",
  },
  {
    title: "Website Development Solutions",
    description:
      "Our expert developers build custom website development and web applications designed to deliver seamless user experiences and long-term scalability.",
    icon: "/img/icons/icon-4.png",
    link: "/digital-marketing-services",
  },
  {
    title: "Ecommerce Solutions",
    description:
      "We design and develop robust e-commerce platforms with secure payment gateways, optimized checkout flows, and sales-driven features to maximize your online revenue.",
    icon: "/img/icons/icon-3.png",
    link: "",
  },
  {
    title: "Marketing Automation",
    description:
      "Streamline your marketing workflows, personalize customer interactions, and track performance with our advanced automation tools.",
    icon: "/img/icons/icon-1.png",
    link: "",
  },
    {
    title: "Mobile App Development Company",
    description:
      "Our team designs and develops custom Mobile App Development for iOS and Android, ensuring innovation, usability, and business impact.",
    icon: "/img/icons/app-development.png",
    link: "",
  },
];

const ServicesSection = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        color: "white",
        padding: "2rem 0",
      }}
    >
      <Container>
        <Card
          sx={{
            padding: "30px",
            background: "transparent",
            border: "1px solid #DADFEF",
            borderRadius: "15px",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              marginBottom: "30px",
              color: "white",
              textAlign: "center",
            }}
          >
            Our Expertise, Your Growth
          </Typography>

          <Grid container spacing={3}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Card className="service-card">
                  <CardContent>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item>
                        <Box
                          component="img"
                          src={service.icon}
                          alt={service.title}
                          sx={{ width: "50px", height: "50px" }}
                        />
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold", color: "#fff" }}
                        >
                          {service.title}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "16px",
                        marginBottom: "15px",
                        color: "#fff",
                      }}
                      mt={2}
                    >
                      {service.description}
                    </Typography>
                    {service.link && (
                      <Button
                        variant="outlined"
                        sx={{
                          color: "#fff",
                          borderRadius: "30px",
                          border:"2px solid #fff",
                          "&:hover": {
                            backgroundColor: "transparent",
                            borderColor: "#D26FD8",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", 
                          },
                        }}
                        onClick={() => navigate(service.link)}
                      >
                        Read More
                      </Button>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Card>
      </Container>
    </Box>
  );
};

export default ServicesSection;
